/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { throttle } from "lodash";
import { View } from "backbone.marionette";
import ClosesOnUserAction from "behaviors/closes_on_user_action";
import { uniqueId } from "underscore";

export default class HeaderDrawerView extends View.extend({
  visibleCourses: 5,
  filtered: false,

  behaviors: {
    closesOnUserAction: {
      behaviorClass: ClosesOnUserAction
    }
  },

  ui: {
    courseSelect: '[data-class="course-select"]',
    recentCourseSelect: '[data-class="recent-course-select"]'
  },

  events: {
    focusout: "onFocusOut"
  }
}) {
  toggle() {
    if (this.$el.hasClass("drawer-open")) {
      return this.close();
    }
    return this.open();
  }

  open() {
    this.setSpacing();
    this.getTrigger().attr({ "aria-expanded": true });
    this.$el.attr({ "data-open": true });
    this.$el.removeAttr("inert");
    this.$el.find("[href],button")[0].focus();

    return this.triggerMethod("opened");
  }

  close() {
    this.getTrigger().attr({ "aria-expanded": false });
    this.$el.attr({ "data-open": false, inert: "" });

    return this.triggerMethod("closed");
  }

  getTrigger() {
    return $(
      `[data-drawer-target="${this.drawerTarget}"][data-behavior="header-drawer-trigger"]`
    );
  }

  setupListeners() {
    this.getUI("courseSelect").on("change", () => {
      const val = this.getUI("courseSelect").val();
      return window.location.assign(val);
    });
    return this.getUI("recentCourseSelect").on("change", () => {
      const val = this.getUI("recentCourseSelect").val();
      return window.location.assign(val);
    });
  }

  setSpacing() {
    const trigger = this.getTrigger();
    if (trigger.length > 0) {
      const { left } = trigger.offset();
      return this.$el.css({ left: left + "px" });
    }
  }

  onFocusOut(event) {
    // If the target isn't inside the dropdown, close the dropdown.
    if (!$.contains(this.$el[0], event.relatedTarget)) {
      this.close();
      this.getTrigger()[0].focus();
    }
  }

  initialize(options) {
    this.vent = options.vent;
    const globalChannel = Radio.channel("globalChannel");
    this.drawerTarget = this.$el.data().drawerTarget;
    // Set Spacing anytime the window is resized
    const throttledSpacing = throttle(() => {
      return this.setSpacing();
    }, 50);
    $(window).resize(() => {
      return throttledSpacing();
    });
    this.listenTo(globalChannel, `drawer:${this.drawerTarget}:toggle`, () => {
      return this.toggle();
    });
    this.bindUIElements();

    const chosenOptions = {
      disable_search_threshold: 1000,
      allow_single_deselect: false,
      placeholder_text_single: "Jump to a different course"
    };
    this.getUI("courseSelect").chosen(chosenOptions);

    const uid = uniqueId("dialog");
    this.$el.attr({
      id: uid,
      role: "dialog",
      inert: ""
    });
    this.getTrigger().attr({
      "aria-expanded": false,
      "aria-haspopup": "dialog",
      "aria-controls": uid
    });

    return this.setupListeners();
  }
}
